import React, { useState, useEffect } from 'react';
import { withApi } from '@tencent/react-aio';
import { getQuery } from '@/utils';
import * as ActionTypes from '@/stores/sale/actions';
import CleanLeadModal from '@/pages/leads/CleanLeadModal.js'; // 清洗线索 线索
import Turn2PotentialModal from '@/pages/leads/Turn2PotentialModal.js'; // 转商机 线索
import CreateActionRecordModal from '@/pages/leads/actionRecords/CreateActionRecordModal'; // 添加跟进记录 订单 商机
import WithPermission from '@/common/permissions/WithPermission';

import { isContain } from '@/utils/ParamUtils';
import fePerms from '@/common/permissions/sale/fePerms';
import perms from '@/common/permissions/sale/perms';
import { cleanLeadPerms } from '@/constants/Constants';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';

import store from './store';

const Index = (props) => {
  const { show, webApi, leadDetail } = props;

  const [detail, setDetail] = useState({});
  const [hideContent, setHide] = useState(false);
  const { effectFn } = store;

  const PROGRESS_STATUS_2_API = {
    PROGRESS_STATUS_LEAD: webApi.getLead,
    PROGRESS_STATUS_POTENTIAL: webApi.getPotential,
    PROGRESS_STATUS_ORDER: webApi.getOrder,
  };

  const fetchDetail = () => {
    if (!leadDetail) {
      return;
    }
    const { leadId, progressStatus } = leadDetail;
    const agencyId = getQuery('agencyId');
    const request = PROGRESS_STATUS_2_API[progressStatus];
    request(leadId, agencyId)
      .dispatchJson(ActionTypes.FETCH_LEAD)
      .then((res) => {
        setDetail(res);
        props.rerenderDialog?.();
      })
      .catch((error) => {
      });
  };

  const editSuccess = () => {
    setHide(true);
    if (effectFn) {
      effectFn();
      store.setEffect(null);
    }
    props.rerenderDialog({ close: true });
  };

  useEffect(() => {
    if (show) {
      // 先呼出再请求详情，呼出会自动添加跟进记录，会更新后端锁，所以延迟请求 detail
      setTimeout(() => {
        fetchDetail();
      }, 1500);
    }
  }, [leadDetail?.leadId, show]);

  if (
    !show
    // || leadDetail?.visibilityScope !== 'VISIBILITY_SCOPE_PRIVATE' // 只处理私海
    || hideContent
  ) {
    return null;
  }

  // 公海
  if (detail?.visibilityScope === 'VISIBILITY_SCOPE_PUBLIC') {
    return (
      <WithPermission
        oneOf={[
          perms.LEAD_EDIT_SELF,
          perms.LEAD_EDIT_GROUP,
          perms.LEAD_EDIT_ALL,
          perms.POTENTIAL_EDIT_SELF,
          perms.POTENTIAL_EDIT_GROUP,
          perms.POTENTIAL_EDIT_ALL,
          perms.ORDER_EDIT_SELF,
          perms.ORDER_EDIT_GROUP,
          perms.ORDER_EDIT_ALL,
        ]}>
        <CreateActionRecordModal
          notDialog
          lead={detail.lead ? detail.lead : detail}
          onSubmit={editSuccess}
        />
      </WithPermission>
    );
  }

  // 线索
  if (leadDetail?.progressStatus === 'PROGRESS_STATUS_LEAD') {
    const { cleanReasonConfig, rerenderDialog } = props;
    return (
      <div>
        {/* 清洗线索 */}
        <WithPermission
          reject={
            cleanLeadPerms.indexOf(detail.cleaningStatus) === -1
            || !isContain(detail.permissions, fePerms.LEAD_CLEAN)
          }
          oneOf={[perms.LEAD_CLEAN_SELF, perms.LEAD_CLEAN_ALL_PENDING]}
        >
          <CleanLeadModal
            notDialog
            leadId={detail.leadId}
            version={detail.version}
            companyName={detail.company?.companyName}
            reasonList={
              cleanReasonConfig.isOpenStateTag
                ? cleanReasonConfig.reasonList
                : {}
            }
            isOpenStateTag={cleanReasonConfig.isOpenStateTag}
            onSubmit={editSuccess}
            rerenderDialog={rerenderDialog}
          />
        </WithPermission>

        {/* 转商机 */}
        <WithPermission
          reject={
            detail.cleaningStatus !== 'CLEANING_STATUS_VALID'
            || !isContain(detail.permissions, fePerms.LEAD_CONVERT)
          }
          allowUser={detail.ownerId}
          oneOf={[
            perms.LEAD_EDIT_SELF,
            perms.LEAD_EDIT_GROUP,
            perms.LEAD_EDIT_ALL,
          ]}
        >
          <Turn2PotentialModal
            notDialog
            webApi={webApi}
            lead={detail}
            onSubmit={editSuccess}
            rerenderDialog={rerenderDialog}
          />
        </WithPermission>
      </div>
    );
  }

  // 商机
  if (leadDetail?.progressStatus === 'PROGRESS_STATUS_POTENTIAL') {
    return (
      <div>
        <WithPermission
          reject={!isContain(detail.permissions, fePerms.POTENTIAL_EDIT)}
          oneOf={[
            perms.POTENTIAL_EDIT_SELF,
            perms.POTENTIAL_EDIT_GROUP,
            perms.POTENTIAL_EDIT_ALL,
          ]}
        >
          <CreateActionRecordModal
            notDialog
            lead={detail.lead}
            potential={detail}
            onSubmit={editSuccess}
          />
        </WithPermission>
      </div>
    );
  }

  // 订单
  if (leadDetail?.progressStatus === 'PROGRESS_STATUS_ORDER') {
    return (
      <div>
        <WithPermission
          reject={!isContain(detail.permissions, fePerms.ORDER_EDIT)}
          oneOf={[
            perms.ORDER_EDIT_SELF,
            perms.ORDER_EDIT_GROUP,
            perms.ORDER_EDIT_ALL,
          ]}
        >
          <CreateActionRecordModal
            notDialog
            lead={detail.lead}
            potential={detail}
            onSubmit={editSuccess}
          />
        </WithPermission>
      </div>
    );
  }

  return null;
};

function mapStateToProps(state) {
  return {
    currentUserId: state.loginStatus.userId,
    customizedFields: state.leadCustomizedFields,
    loginStatus: state.loginStatus,
    cleanReasonConfig: state.cleanReasonConfig,
    whiteList: state.customerProtectionWhiteList,
  };
}

export default withApi(connect(mapStateToProps)(observer(Index)));
